import { createFileRoute } from '@tanstack/react-router'

import { BrokerSyncRunsPage } from '#/modules/fmcsa/sync-runs-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/broker-sync')({
  component: BrokerSyncRunsPage,
  validateSearch: validateListSearch,
})
